import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=7fc8d996&scoped=true&lang=pug"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"
import style0 from "./order-details.vue?vue&type=style&index=0&id=7fc8d996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc8d996",
  null
  
)

export default component.exports